import * as React from 'react';
import { Form, Text, Select } from 'react-form';
import { BaseFormProps } from '../../interfaces';
import { Language, Characteristic } from '../../models';
import { CharacteristicDataService, LanguageDataService, NotificationService } from '../../services';

interface CharacteristicScoreEditState {
    characteristics: Characteristic[];
    languages: Language[];
    addLanguageId: number;
}

interface CharacteristicScoreFormProps extends BaseFormProps {
    notificationService: NotificationService;
}

export class CharacteristicScoreForm extends React.Component<CharacteristicScoreFormProps, CharacteristicScoreEditState> {
    private characteristicDataService = new CharacteristicDataService(this.props.notificationService);
    private languageDataService = new LanguageDataService(this.props.notificationService);

    constructor(props: CharacteristicScoreFormProps) {
        super(props);

        this.props.defaultValues.questionTexts = this.props.defaultValues.questionTexts || [];
        this.props.defaultValues.characteristicScores = this.props.defaultValues.characteristicScores || [];
        this.props.defaultValues.addLanguageId = 1;
    }

    public componentDidMount() {

        this.setState({
            characteristics: [],
            languages: [],
            addLanguageId: 1
        });

        this.characteristicDataService.getAll().then((characteristics: Characteristic[]) => {
            this.setState({
                characteristics: characteristics
            });

            this.languageDataService.getAll().then((languages: Language[]) => {
                this.setState({
                    languages: languages
                });
                this.forceUpdate();
            });
        });
    }

    // private addLanguage() {
    //     var qt = new QuestionText();
    //     for(var i = 0; i < this.state.languages.length; i++) {
    //         if(this.state.languages[i].id == this.state.addLanguageId) {
    //             qt.language = this.state.languages[i];
    //             break;
    //         }
    //     }
    //     qt.languageId = this.state.addLanguageId;
    //     this.props.defaultValues.questionTexts.push(qt);
    //     this.forceUpdate();
    // }

    // private addLanguageBinder(): ((event: React.MouseEvent<HTMLElement>) => void) {
    //     return this.addLanguage.bind(this);
    // }

    // private addCharacterstic() {
    //     var c = new CharacteristicScore();
    //     c.highScore = 0.75;
    //     c.lowScore = 0.25;
    //     this.props.defaultValues.characteristicScores.push(c);
    //     this.forceUpdate();
    // }

    // private addCharactersticBinder(): ((event: React.MouseEvent<HTMLElement>) => void) {
    //     return this.addCharacterstic.bind(this);
    // }

    // private addLanguageChange(event: any) {
    //     this.setState({
    //         addLanguageId: event.currentTarget.value
    //     })
    // }

    // private addLanguageChangeBinder(): ((event: React.FormEvent<HTMLSelectElement>) => void) {
    //     return this.addLanguageChange.bind(this);
    // }

    public render() {
        if (!this.state) {
            return <div />;
        }

        const languages: any = [];
        if (this.state.languages) {
            this.state.languages.map((x: Language) => {
                languages.push({
                    label: x.name,
                    value: x.id
                });
            });
        }

        const questionTypes = [{
            label: 'Likert',
            value: 'scale'
        },
        {
            label: 'True/False',
            value: 'binary'
        }];

        const scoreTypes = [{
            label: 'Normal',
            value: 1
        }, {
            label: 'Tot_Inconsist',
            value: 2
        }, {
            label: 'Tot_PosImp',
            value: 3
        }, {
            label: 'Tot_NegImp',
            value: 4
        }, {
            label: 'Tot_Clinical',
            value: 5
        }];

        const characteristicTypes = this.state.characteristics.map((x: Characteristic) => {
            return {
                label: x.name,
                value: x.id
            };
        });

        return (
            <Form defaultValues={this.props.defaultValues} onSubmit={submittedValues => this.props.submit(submittedValues)}>
                {formApi => (
                    <form onSubmit={formApi.submitForm} id="entityForm">
                        <div className="form-group">
                            <label htmlFor="name">Characteristic Score</label>
                            <Select className="form-control" field="questionType" options={questionTypes} />
                        </div>

                        <div className="row">
                            <div className="col-xs-6">
                                <div className="form-group">
                                    <label htmlFor="questionText">Characteristic Type</label>
                                    <Select className="form-control" field={['characteristicId']} options={characteristicTypes} />
                                </div>
                            </div>
                            <div className="col-xs-6">
                                <div className="form-group">
                                    <label htmlFor="questionText">Score Type</label>
                                    <Select className="form-control" field={['scoreTypeId']} options={scoreTypes} />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xs-6">
                                <div className="form-group">
                                    <label htmlFor="questionText">High Weight</label>
                                    <Text className="form-control" placeholder="Percentage 0.0 to 1.0" type="text" field={['highScore']} />
                                </div>
                            </div>
                            <div className="col-xs-6">
                                <div className="form-group">
                                    <label htmlFor="questionText">Low Weight</label>
                                    <Text className="form-control" placeholder="Percentage 0.0 to 1.0" type="text" field={['lowScore']} />
                                </div>
                            </div>
                        </div>

                        <br />

                        <button type="submit" className="btn btn-primary">Save</button>
                    </form>
                )}
            </Form>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/characteristicscore/CharacteristicScoreForm.tsx